export default "/images/vendor/flag-icons/flags/4x3/bb.svg?0506d6bd800e84fd292390e640343f36";